module.exports = __webpack_public_path__ + "static/img/sliderIcon.f5562412.svg";